export const explanatoryTextRubrics = [
	{
		name: "Förklarande text",
		grade: "åk3",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Förklaring och analys",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Ett tydligt exempel med detaljer 2) Förklarar varför något händer 3) Visar att man förstår ämnet 4) Säger vad man tycker",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Ett exempel 2) Försöker förklara varför 3) Några fakta om ämnet",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Nämner något exempel 2) Berättar lite om ämnet 3) Någon enkel fakta",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Exempel 2) Information 3) Fakta",
					},
				],
			},
			{
				name: "Sammanhang och kopplingar",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Texten hänger ihop 2) Använder ord som 'för att' och 'eftersom' 3) Lätt att följa 4) Bra ordning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Det mesta går att förstå 2) Använder ord som 'och' och 'men' 3) Ganska bra ordning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Man förstår det viktiga 2) Enkel ordning 3) Går att läsa",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Ordning 2) Förståelse 3) Sammanhang",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Början som berättar vad texten handlar om 2) Två stycken text 3) Ett bra slut 4) Använder och, men",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) En början 2) Text i mitten 3) Ett slut 4) Några bindeord",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Man ser var texten börjar och slutar 2) Texten har några meningar 3) Enkel ordning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Start och slut 2) Ordning i texten 3) Tydliga meningar",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Använder fackord på rätt sätt 2) Meningar med punkt 3) Stor bokstav i början 4) Lätt att läsa stavningen",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Försöker använda fackord 2) De flesta meningar har punkt 3) Oftast stor bokstav",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Använder vanliga ord rätt 2) Några punkter finns 3) Går att läsa texten",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Förståeliga ord 2) Punkter 3) Läsbar text",
					},
				],
			},
		],
	},
	{
		name: "Förklarande text",
		grade: "åk4",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Förklaring och analys",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Ett detaljerat exempel med fakta 2) Förklarar orsak och verkan 3) Visar olika möjligheter 4) Egen åsikt med förklaring",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Ett exempel med några detaljer 2) Förklarar hur saker hänger ihop 3) Visar att man förstår ämnet",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Ett enkelt exempel 2) Försöker förklara 3) Några fakta finns med",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Exempel 2) Förklaringar 3) Fakta",
					},
				],
			},
			{
				name: "Sammanhang och kopplingar",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Allt hänger ihop bra 2) Använder eftersom, därför 3) Lätt att följa med 4) Bra flyt i texten",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Det mesta hänger ihop 2) Använder och, men, för att 3) Ganska lätt att följa",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Några delar hänger ihop 2) Några bindeord 3) Man förstår texten",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Sammanhang 2) Bindeord 3) Förståelig text",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Bra början som förklarar 2) Två-tre stycken i ordning 3) Bra avslutning 4) Bindeord som hjälper",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydlig början 2) Två stycken 3) Ett slut 4) Några bindeord",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Man ser start och slut 2) Texten är uppdelad 3) Enkel ordning finns",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Start/slut 2) Stycken 3) Ordning",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Använder flera fackord korrekt 2) Hela meningar med punkt 3) Olika sorters meningar 4) Bra stavning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Använder några fackord rätt 2) Meningar med punkt och stor bokstav 3) Ganska bra stavning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Försöker använda fackord 2) De flesta meningar har punkt 3) Man förstår stavningen",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fackord 2) Punkter och stor bokstav 3) Läsbar text",
					},
				],
			},
		],
	},
	{
		name: "Förklarande text",
		grade: "åk5",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Förklaring och analys",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Två exempel med detaljer 2) Förklarar samband tydligt 3) Visar olika perspektiv 4) Motiverad egen åsikt",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Ett bra exempel med detaljer 2) Förklarar några samband 3) Ett perspektiv visas",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Ett exempel finns 2) Enkel förklaring 3) Några grundfakta",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Exempel 2) Förklaringar 3) Fakta",
					},
				],
			},
			{
				name: "Sammanhang och kopplingar",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydliga kopplingar överallt 2) Bra bindeord som eftersom, därför 3) Lätt att följa 4) Naturliga övergångar",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Flera kopplingar finns 2) Använder och, men, för att 3) Går bra att följa",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Några kopplingar 2) Enkla bindeord 3) Man förstår texten",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Kopplingar 2) Bindeord 3) Förståelse",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Intressant början 2) Minst tre stycken i ordning 3) Bra avslutning 4) Variation i bindeord",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydlig början 2) Två-tre stycken 3) Avslutning finns 4) Några bindeord",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Början och slut finns 2) Uppdelad text 3) Viss ordning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Struktur 2) Stycken 3) Ordning",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Använder fackord korrekt och varierat 2) Varierande meningar 3) Bra flyt i språket 4) Nästan inga stavfel",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Använder flera fackord rätt 2) Hela meningar med skiljetecken 3) Få stavfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Några fackord används 2) Enkla hela meningar 3) Stavning som fungerar",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fackord 2) Hela meningar 3) Fungerande stavning",
					},
				],
			},
		],
	},
	{
		name: "Förklarande text",
		grade: "åk6",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: "2025-01-09T09:38:30.000Z",
		criteria: [
			{
				name: "Förklaring och analys",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Två-tre exempel med detaljer 2) Förklarar tydliga samband 3) Visar olika perspektiv 4) Egen analys med slutsatser",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Två exempel med detaljer 2) Förklarar flera samband 3) Försöker visa olika perspektiv",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Ett utvecklat exempel 2) Enkel förklaring av samband 3) Grundläggande fakta",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Utvecklade exempel 2) Förklaringar 3) Relevanta fakta",
					},
				],
			},
			{
				name: "Sammanhang och kopplingar",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydlig röd tråd 2) Varierade bindeord som eftersom, därför 3) Bra flyt i texten 4) Naturliga övergångar",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Flera tydliga kopplingar 2) Använder och, men, eftersom 3) Texten hänger ihop bra",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande kopplingar 2) Enkla bindeord 3) Texten går att följa",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Kopplingar 2) Bindeord 3) Följbar struktur",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Fångande början 2) 3-4 välordnade stycken 3) Avrundande avslutning 4) Variation i styckeövergångar",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydlig början 2) Tre stycken 3) Fungerande avslutning 4) Enkel styckeindelning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel början och slut 2) Minst två stycken 3) Viss ordning i texten",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Struktur 2) Styckeindelning 3) Ordning",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Använder fackord korrekt och säkert 2) Varierande meningar 3) Tydligt språkflyt 4) Få språkfel",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Använder flera fackord korrekt 2) Tydliga meningar med skiljetecken 3) Några få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Några fackord används rätt 2) Begripliga meningar 3) Fungerande stavning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fackord 2) Hela meningar 3) Läsbar text",
					},
				],
			},
		],
	},
	{
		name: "Förklarande text",
		grade: "åk7",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Förklaring och analys",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Flera relevanta exempel med detaljer 2) Analyserar orsak och verkan 3) Jämför olika perspektiv 4) Välgrundade slutsatser",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Två exempel med förklaringar 2) Visar några samband 3) Diskuterar ett perspektiv",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Ett utvecklat exempel 2) Enkel analys 3) Grundläggande fakta",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Utvecklade exempel 2) Analys 3) Relevanta fakta",
					},
				],
			},
			{
				name: "Sammanhang och kopplingar",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Genomgående röd tråd 2) Avancerade bindeord 3) Tydlig progression 4) Smidiga övergångar",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Logiska kopplingar 2) Varierade bindeord 3) Texten flyter på",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande kopplingar 2) Enkla bindeord 3) Texten går att följa",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Logiska kopplingar 2) Bindeord 3) Följbar struktur",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Effektiv inledning 2) 4-5 välstrukturerade stycken 3) Sammanfattande slutsats 4) Konsekvent styckeindelning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydlig inledning 2) 3-4 stycken 3) Fungerande avslutning 4) Logisk styckeindelning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel inledning och avslut 2) Minst 3 stycken 3) Enkel struktur",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydlig struktur 2) Styckeindelning 3) Inledning/avslutning",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Använder fackord precist och korrekt 2) Varierat språk 3) Effektiva formuleringar 4) Korrekt stavning och skiljetecken",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Använder fackord på fungerande sätt 2) Tydliga meningar 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Försöker använda fackord 2) Begripliga meningar 3) Acceptabel stavning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fackord 2) Fungerande meningar 3) Läsbar text",
					},
				],
			},
		],
	},
	{
		name: "Förklarande text",
		grade: "åk8",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Förklaring och analys",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Flera välutvecklade exempel 2) Djupgående analys av orsakssamband 3) Kritisk jämförelse av perspektiv 4) Välgrundade slutsatser med källor",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Två-tre utvecklade exempel 2) Analys av samband 3) Olika perspektiv presenteras",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Ett utvecklat exempel 2) Enkel analys 3) Ett perspektiv visas",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Utvecklade exempel 2) Analys 3) Relevanta slutsatser",
					},
				],
			},
			{
				name: "Sammanhang och kopplingar",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Stark röd tråd genom hela texten 2) Använder avancerade bindeord 3) Tydlig tankegång 4) Naturliga övergångar mellan stycken",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydliga kopplingar mellan stycken 2) Varierade bindeord 3) Lätt att följa resonemanget",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Texten hänger ihop 2) Några bindeord används 3) Går att följa tankegången",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Sammanhang 2) Bindeord 3) Tydlig tankegång",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Stark inledning som fångar läsaren 2) Minst 5 väl utformade stycken 3) Övertygande slutsats 4) Genomtänkt styckeindelning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Bra inledning 2) 3-4 utvecklade stycken 3) Tydlig avslutning 4) Fungerande styckeindelning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel inledning och avslutning 2) Minst 3 stycken 3) Viss struktur finns",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Inledning/avslutning 2) Styckeindelning 3) Struktur",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Precist och korrekt fackspråk 2) Välformulerat och varierat språk 3) Tydliga formuleringar 4) Korrekt stavning och skiljetecken",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Fackspråk används tydligt 2) Bra meningsbyggnad 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Försöker använda fackspråk 2) Fungerande meningar 3) Begriplig stavning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fackspråk 2) Fungerande meningar 3) Läsbar text",
					},
				],
			},
		],
	},
	{
		name: "Förklarande text",
		grade: "åk9",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Förklaring och analys",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Flera välutvecklade exempel med djup 2) Djup analys av orsakssamband 3) Kritisk jämförelse av olika perspektiv 4) Välgrundade slutsatser med källor",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Två-tre utvecklade exempel 2) Analys av samband 3) Olika perspektiv diskuteras",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Ett-två exempel med förklaring 2) Enkel analys 3) Ett perspektiv presenteras",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Utvecklade exempel 2) Analys 3) Tydliga perspektiv",
					},
				],
			},
			{
				name: "Sammanhang och kopplingar",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Genomgående stark röd tråd 2) Avancerade bindeord och övergångar 3) Tydlig progression 4) Väl sammanhängande text",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydliga kopplingar 2) Varierande bindeord 3) Texten flyter bra",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande sammanhang 2) Några bindeord 3) Texten går att följa",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Sammanhang 2) Bindeord 3) Följbar struktur",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Effektiv och intresseväckande inledning 2) Minst 5 välutvecklade stycken 3) Stark avslutning med slutsatser 4) Genomtänkt styckeindelning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydlig inledning 2) 4-5 utvecklade stycken 3) Bra avslutning 4) Logisk styckeindelning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel inledning och avslutning 2) Minst 3 stycken 3) Viss struktur finns",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Inledning/avslutning 2) Styckeindelning 3) Struktur",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Konsekvent och korrekt fackspråk 2) Välformulerat och precist språk 3) Effektiva formuleringar 4) Korrekt stavning och skiljetecken",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt fackspråk 2) Bra meningsbyggnad 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Försöker använda fackspråk 2) Fungerande meningar 3) Begriplig stavning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fackspråk 2) Fungerande meningar 3) Läsbar text",
					},
				],
			},
		],
	},
	{
		name: "Förklarande text",
		grade: "firstRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Förklaring och analys",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Genomtänkta exempel som stödjer analysen 2) Djupgående analys av komplexa samband 3) Nyanserad jämförelse av perspektiv 4) Självständiga och välgrundade slutsatser med källhänvisningar",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Relevanta exempel med utveckling 2) Tydlig analys av samband 3) Olika perspektiv analyseras",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Exempel med viss analys 2) Grundläggande resonemang 3) Något perspektiv behandlas",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Relevanta exempel 2) Analys 3) Perspektiv",
					},
				],
			},
			{
				name: "Sammanhang och kopplingar",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Genomarbetad röd tråd 2) Effektiva övergångar och bindeord 3) Logisk progression 4) Övertygande argumentation",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydlig struktur 2) Fungerande övergångar 3) Utvecklat resonemang",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Viss röd tråd 2) Enkla övergångar 3) Grundläggande resonemang",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Struktur 2) Övergångar 3) Resonemang",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Engagerande och relevant inledning 2) Väldisponerade stycken med tydlig funktion 3) Övertygande slutsatser 4) Genomtänkt styckeindelning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklad inledning 2) Logiskt ordnade stycken 3) Tydlig avslutning 4) Fungerande disposition",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande inledning och avslutning 2) Urskiljbara stycken 3) Viss struktur",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Disposition 2) Styckeindelning 3) Struktur",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Träffsäkert och varierat fackspråk 2) Välformulerat och nyanserat språk 3) Effektiv meningsbyggnad 4) Genomgående korrekt språk",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Relevant fackspråk 2) Tydlig meningsbyggnad 3) Mestadels korrekt språk",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Viss användning av fackspråk 2) Förståelig meningsbyggnad 3) Grundläggande språkriktighet",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fackspråk 2) Fungerande meningsbyggnad 3) Språkriktighet",
					},
				],
			},
		],
	},
	{
		name: "Förklarande text",
		grade: "secondRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Förklaring och analys",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Träffsäkra exempel som fördjupar analysen 2) Självständig analys av komplexa samband 3) Kritisk jämförelse av perspektiv 4) Välgrundade slutsatser med relevant källanvändning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklade exempel med analys 2) Tydliga samband visas 3) Perspektiv diskuteras och jämförs",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Exempel med resonemang 2) Vissa samband visas 3) Perspektiv behandlas",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Utvecklade exempel 2) Samband 3) Perspektiv",
					},
				],
			},
			{
				name: "Sammanhang och kopplingar",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Övertygande röd tråd 2) Skickligt använd textbindning 3) Effektiv progression 4) Självständig argumentation",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Genomtänkt struktur 2) God textbindning 3) Utvecklat resonemang",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Urskiljbar struktur 2) Fungerande textbindning 3) Enkelt resonemang",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Struktur 2) Textbindning 3) Resonemang",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Effektiv och tankeväckande inledning 2) Skickligt disponerade stycken 3) Nyanserad slutsats 4) Genomtänkt helhet",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Genomarbetad inledning 2) Välordnade stycken 3) Tydlig slutsats 4) Fungerande disposition",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande inledning och avslutning 2) Styckeindelning finns 3) Viss disposition",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Struktur 2) Styckeindelning 3) Disposition",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Självständigt och precist fackspråk 2) Stilistiskt säkert språk 3) Varierad meningsbyggnad 4) Genomgående språklig säkerhet",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Säkert fackspråk 2) Tydligt språk 3) God språkhantering",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande fackspråk 2) Fungerande språk 3) Viss språkhantering",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fackspråk 2) Fungerande språk 3) Språkhantering",
					},
				],
			},
		],
	},
	{
		name: "Förklarande text",
		grade: "thirdRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-01-09T09:38:30.000Z"),
		criteria: [
			{
				name: "Förklaring och analys",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Skickligt valda exempel som fördjupar analysen 2) Självständig och nyanserad analys 3) Kritisk och mångsidig perspektivjämförelse 4) Välunderbyggda slutsatser med gedigen källhantering",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Relevanta exempel med god analys 2) Tydliga samband analyseras 3) Perspektiv jämförs och värderas",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Exempel med viss analys 2) Samband diskuteras 3) Perspektiv presenteras",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Analyserade exempel 2) Samband 3) Perspektiv",
					},
				],
			},
			{
				name: "Sammanhang och kopplingar",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Elegant och övertygande röd tråd 2) Avancerad textbindning 3) Effektiv argumentation 4) Självständigt och kritiskt förhållningssätt",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Välutvecklad struktur 2) Säker textbindning 3) Övertygande resonemang",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande struktur 2) Fungerande textbindning 3) Enkelt resonemang",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Struktur 2) Textbindning 3) Resonemang",
					},
				],
			},
			{
				name: "Struktur och disposition",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Skicklig och engagerande inledning 2) Effektiv styckeindelning 3) Övertygande slutsatser 4) Retoriskt genomtänkt helhet",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Välformulerad inledning 2) Genomtänkt styckeindelning 3) Utvecklad slutsats 4) Tydlig disposition",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande inledning och avslutning 2) Grundläggande styckeindelning 3) Viss disposition",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Struktur 2) Styckeindelning 3) Disposition",
					},
				],
			},
			{
				name: "Språk och ordval",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Träffsäkert och självständigt fackspråk 2) Stilistiskt skickligt språk 3) Retoriskt effektiv meningsbyggnad 4) Genomgående språklig säkerhet",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Säkert fackspråk 2) Välutvecklat språk 3) God språkhantering",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande fackspråk 2) Fungerande språk 3) Acceptabel språkhantering",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fackspråk 2) Fungerande språk 3) Språkhantering",
					},
				],
			},
		],
	},
];
